export default class DefaultValue {
    constructor(play, fragment, summaryContext, team) {
        this.play = play;
        this.fragment = fragment;
        this.summaryContext = summaryContext;
        this.team = team;
    }

    resolve() {
        return undefined;
    }
}
